import { Box, Button, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'swiper/swiper-bundle.css'

import SeriesQ from '@/queries/SeriesQ'
import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { getUserUrl } from '@/client/services/url'

import TutorFollowButton from '@/components/Buttons/TutorFollowButton'
import SeriesBoxFromQuery from '@/components/Series/SeriesBox/SeriesBoxFromQuery'
import ShwLink from '@/components/ShwLink'

export default function ProfileUpcomingSessions({
  user,
  upcomingSeries,
}: {
  user: Query
  upcomingSeries: Query[]
}): JSX.Element | null {
  const userId = user(UserQ.id) ?? 0
  const username = user(UserQ.username)
  const firstName = user(UserQ.first_name) ?? ''
  const isUserTutor = user(UserQ.hasTutorRole()) ?? false

  if (upcomingSeries.length > 0) {
    return (
      <Box>
        <Stack spacing={2} direction="row" justify="space-between" align="flex-start" mb={3}>
          <Heading size="xl">Upcoming Sessions</Heading>
          <ShwLink href={getUserUrl({ userId, username, path: 'sessions' })}>
            <Button variant="ghost" rightIcon={<FontAwesomeIcon icon={faChevronRight} />}>
              See All
            </Button>
          </ShwLink>
        </Stack>
        <SimpleGrid columns={[1, 1, 1, 2]} spacing="16px">
          {upcomingSeries.slice(0, 4).map(series => (
            <SeriesBoxFromQuery series={series} key={series(SeriesQ.id) ?? 0} />
          ))}
        </SimpleGrid>
      </Box>
    )
  }
  return upcomingSeries.length === 0 && isUserTutor ? (
    <Box>
      <Stack spacing={2} direction="row" justify="space-between" align="flex-start" mb={3}>
        <Heading size="xl">Upcoming Sessions</Heading>
        <ShwLink href={getUserUrl({ userId, username, path: 'sessions' })}>
          <Button variant="ghost" rightIcon={<FontAwesomeIcon icon={faChevronRight} />}>
            See All
          </Button>
        </ShwLink>
      </Stack>
      <Box
        bg="blackAlpha.50"
        borderRadius={8}
        p={12}
        border="2px dashed"
        borderColor="border.emphasized"
      >
        <Stack align="center">
          <Text align="center" color="fg.muted" pb={4}>
            {firstName} isn&apos;t hosting anything soon, but you can follow them to get updates on
            future sessions.
          </Text>
          <Stack direction="row" spacing={2}>
            <TutorFollowButton
              tutor={user}
              followText={`Follow ${firstName}`}
              followingText={`Following ${firstName}`}
              width="auto"
            />
            <ShwLink href={getUserUrl({ userId, username, path: 'sessions' })}>
              <Button variant="outline">See Past Sessions</Button>
            </ShwLink>
          </Stack>
        </Stack>
      </Box>
    </Box>
  ) : null
}
